import React from 'react'
// Ui
import Box from 'ui/Box'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Input from 'ui/Form/Input'
import AvatarPicker from 'ui/Form/AvatarPicker'
import PropTypes from 'prop-types'
// Bootstrap
import { Form } from 'react-bootstrap'
// Use
import { useTablet } from 'use/media'

const LessorUpdateView = ({ profile }) => {
  const isTablet = useTablet()
  return (
    <Box
      style={{
        border: '1px solid #EBEEF5',
        borderRadius: '4px',
      }}
    >
      <AvatarPicker disabled={true} value={profile.profilePhoto} />
      <Row>
        <Col sm={8} md={5}>
          <Input
            value={profile.lessorName}
            disabled={true}
            label="Full name"
            placeholder="Enter your name"
          />
        </Col>
        <Col md={{ span: 4, offset: 1 }} />
      </Row>
      <Row>
        <Col sm={8} md={5}>
          <Input
            value={profile.email}
            disabled={true}
            label="Emaill address"
            placeholder="Enter your email address"
          />
        </Col>
        <Col sm={8} md={{ span: 5, offset: 1 }}>
          <Input
            value={profile.mobiNo}
            disabled={true}
            label="Contact no."
            placeholder="+63 XXXXXXXXXX"
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={11}>
          <Input
            value={profile.mailingAddress}
            disabled={true}
            textarea={!isTablet}
            label="Mailing address"
            placeholder="Enter your email address"
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group>
            <Form.Label>Allow SMS notif ?</Form.Label>
            <div>
              <strong className="label-top text-dark">
                {profile.notificationSMS ? 'Yes' : 'No'}
              </strong>
            </div>
          </Form.Group>
        </Col>
      </Row>
    </Box>
  )
}
LessorUpdateView.propTypes = {
  profile: PropTypes.object,
}

LessorUpdateView.defaultProps = {
  profile: {},
}

export default LessorUpdateView
